import { render } from "./Style.vue?vue&type=template&id=65f44f6e&scoped=true"
import script from "./Style.vue?vue&type=script&lang=js"
export * from "./Style.vue?vue&type=script&lang=js"

import "./Style.vue?vue&type=style&index=0&id=65f44f6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f44f6e"]])

export default __exports__